import { ERROR_MESSAGES, FIELD_KEYS } from './constants';

const validateMinimum = ({ newValue, curMax, individualMin }) => {
  if (Number.isNaN(newValue)) {
    return ERROR_MESSAGES.mustBeNumberMin;
  }
  if (newValue < 0) {
    return ERROR_MESSAGES.minTooLow;
  }
  if (newValue > curMax) {
    return ERROR_MESSAGES.minExceedsMax;
  }
  if (individualMin != null && newValue < individualMin) {
    return ERROR_MESSAGES.minBelowIndividualMin;
  }
  return null;
};

const validateMaximum = ({ newValue, curMin, choicesCount, individualMax }) => {
  if (Number.isNaN(newValue)) {
    return ERROR_MESSAGES.mustBeNumberMax;
  }
  if (newValue <= 0) {
    return ERROR_MESSAGES.maxTooLow;
  }
  if (newValue > 99) {
    return ERROR_MESSAGES.maxTooHigh;
  }
  if (newValue < curMin) {
    return ERROR_MESSAGES.maxBelowMin;
  }
  if (choicesCount > 0 && newValue > choicesCount) {
    return ERROR_MESSAGES.maxExceedsChoices;
  }
  if (individualMax != null && newValue < individualMax) {
    return ERROR_MESSAGES.maxBelowIndividualMax;
  }
  return null;
};

const validateField = (field, newValue, modifierGroup) => {
  const { minimum, maximum, children, individualMinimum, individualMaximum } = modifierGroup;
  if (field === FIELD_KEYS.min) {
    return validateMinimum({ newValue, curMax: maximum, individualMin: individualMinimum });
  }
  return validateMaximum({
    newValue,
    curMin: minimum,
    choicesCount: children?.length || 0,
    individualMax: individualMaximum,
  });
};

export { validateField };
